var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"digicoop-dragonpay-success"},[_c('app-digicoop-dragonpay-success-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }